export default __webpack_public_path__ + "static/media/marioVideo2.80cd9ce8.webm";